import { motion, type HTMLMotionProps } from 'motion/react';
import { cn } from '../../lib/cn';

// Surface card with a subtle lift on hover when interactive.

export function Card({
  className,
  interactive,
  ...rest
}: HTMLMotionProps<'div'> & { interactive?: boolean }) {
  return (
    <motion.div
      whileHover={interactive ? { y: -3 } : undefined}
      transition={{ type: 'spring', stiffness: 400, damping: 28 }}
      className={cn('rounded-xl border border-border bg-surface elevated', className)}
      {...rest}
    />
  );
}

export function Badge({
  children,
  tone = 'neutral',
}: {
  children: React.ReactNode;
  tone?: 'neutral' | 'accent' | 'success' | 'warning';
}) {
  const tones = {
    neutral: 'bg-subtle text-muted',
    accent: 'bg-accent/20 text-text',
    success: 'bg-success/12 text-success',
    warning: 'bg-warning/12 text-warning',
  };
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-2xs font-bold uppercase tracking-wide',
        tones[tone],
      )}
    >
      {children}
    </span>
  );
}
